import { render, staticRenderFns } from "./devishabitation.vue?vue&type=template&id=37603ce4&scoped=true"
import script from "./devishabitation.vue?vue&type=script&lang=js"
export * from "./devishabitation.vue?vue&type=script&lang=js"
import style0 from "./devishabitation.vue?vue&type=style&index=0&id=37603ce4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37603ce4",
  null
  
)

export default component.exports